import { useEffect, useState } from 'react'

import clsx from 'clsx'

import { applyReactionToggle } from '../model/reactions'

export const ReactionBar = ({ allowedEmojis = [], reactionsSummary = {}, myReaction, onToggle }) => {
  // Palpite otimista enquanto o POST está no ar; `null` no estado normal, para
  // que o desenhado seja sempre o resumo do servidor. Antes a barra guardava
  // uma cópia da prop feita no mount e nunca mais atualizada, então nem o
  // repoll de 30s do `useFeedPosts` nem o invalidate pós-mutation chegavam à
  // tela — reação de outro participante jamais aparecia.
  const [optimistic, setOptimistic] = useState(null)

  const serverState = JSON.stringify([reactionsSummary, myReaction ?? null])
  useEffect(() => {
    setOptimistic(null)
  }, [serverState])

  if (!allowedEmojis.length) return null

  const summary = optimistic?.summary ?? reactionsSummary
  const mine = optimistic ? optimistic.myReaction : myReaction ?? null

  const handleClick = async emoji => {
    setOptimistic(applyReactionToggle(summary, mine, emoji))

    try {
      await onToggle(emoji)
    } catch {
      setOptimistic(null)
    }
  }

  return (
    <div className="flex flex-wrap gap-1 mt-2">
      {allowedEmojis.map(emoji => (
        <button
          key={emoji}
          type="button"
          onClick={() => handleClick(emoji)}
          aria-pressed={mine === emoji}
          className={clsx(
            // Mesma pílula canônica do HeartReactionButton (shared/ui/Reactions):
            // rounded-lg, hit-area expandida (after:-inset-2), focus ring,
            // scale no active. Cor ativa fica em primary, não no vermelho do
            // "curtir" — aqui o pill representa qualquer emoji, não só like.
            'relative inline-flex min-h-8 shrink-0 items-center gap-1.5 rounded-lg border border-solid px-2.5 py-1.5 text-base transition-all duration-150',
            'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--color-ring)]',
            'motion-safe:active:scale-[0.96]',
            'after:absolute after:-inset-2 after:content-[""]',
            mine === emoji
              ? 'border-primary bg-primary/10 text-primary'
              : 'border-gray-200 bg-gray-100 text-gray-600 shadow-sm hover:border-primary/30 hover:bg-primary/5 hover:text-primary'
          )}
        >
          {/* O emoji é o nome acessível do botão — não esconder do leitor. */}
          <span className="relative z-[1] shrink-0">{emoji}</span>
          {(summary[emoji] || 0) > 0 && (
            <span
              className={clsx(
                'relative z-[1] text-xs font-bold leading-none tabular-nums',
                mine === emoji ? 'text-primary' : 'text-gray-700'
              )}
            >
              {summary[emoji]}
            </span>
          )}
        </button>
      ))}
    </div>
  )
}
